import { motion } from "framer-motion";
import styles from "./Counter.module.scss";
import { Fragment } from "react/jsx-runtime";

const digits = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9];
const numberOfDigits = digits.length;

export default function Counter({
  number,
  symbol,
  delay = 0,
}: {
  number: number;
  symbol: string;
  delay?: number;
}) {
  const inputNumberArray = number
    .toString()
    .split("")
    .map((num) => parseInt(num));

  return (
    <div className={styles.counter}>
      <h1>
        {inputNumberArray.map((num, i) => (
          <div key={i} className={styles.numberFrame}>
            <motion.div
              className={styles.numberRow}
              initial={{ y: "0%" }}
              animate={{
                y:
                  i === 0
                    ? `-${(100 / numberOfDigits) * num}%`
                    : // add extra translation when the factor is higher than 0
                      `-${(100 / numberOfDigits) * num + ((100 / numberOfDigits) * num) / Math.pow(10, i)}%`,
              }}
              transition={{ duration: 0.5, ease: "linear", delay: delay }}
            >
              {/* Render voor de tientallen 10x het aantal nummers en voor honderdtallen 100x etc. */}
              {Array.from({ length: Math.pow(10, i) }).map((_, i) => {
                return (
                  <Fragment key={i}>
                    {/* Render 1 rij nummers */}
                    {digits.map((digit, j) => (
                      <span key={j}>{digit}</span>
                    ))}
                  </Fragment>
                );
              })}
            </motion.div>
          </div>
        ))}
        <span>{symbol}</span>
      </h1>
    </div>
  );
}
